// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=IBM+Plex+Mono:wght@600&family=Archivo:wdth,wght@112,700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html,
body,
#root {
  height: 100%;
}

body {
  background: #04081a;
  color: #dbe4ec;
  font-family: 'IBM Plex Mono', ui-monospace, monospace;
  -webkit-font-smoothing: antialiased;
  overflow: hidden;
}

/* The stacked mobile layout is taller than the viewport by design, so it has
   to be allowed to scroll. */
@media (max-width: 900px) {
  html,
  body,
  #root {
    height: auto;
    min-height: 100%;
  }

  body {
    overflow-y: auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;;;EAGE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qDAAqD;EACrD,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;6BAC6B;AAC7B;EACE;;;IAGE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=IBM+Plex+Mono:wght@600&family=Archivo:wdth,wght@112,700&display=swap');\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nhtml,\nbody,\n#root {\n  height: 100%;\n}\n\nbody {\n  background: #04081a;\n  color: #dbe4ec;\n  font-family: 'IBM Plex Mono', ui-monospace, monospace;\n  -webkit-font-smoothing: antialiased;\n  overflow: hidden;\n}\n\n/* The stacked mobile layout is taller than the viewport by design, so it has\n   to be allowed to scroll. */\n@media (max-width: 900px) {\n  html,\n  body,\n  #root {\n    height: auto;\n    min-height: 100%;\n  }\n\n  body {\n    overflow-y: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
